import { render, staticRenderFns } from "./carbon.vue?vue&type=template&id=78cd9562&scoped=true&"
import script from "./carbon.vue?vue&type=script&lang=js&"
export * from "./carbon.vue?vue&type=script&lang=js&"
import style0 from "./carbon.vue?vue&type=style&index=0&id=78cd9562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd9562",
  null
  
)

export default component.exports